import React from "react";
import "./Badges.css";
import { getCreditTypeLabel, isRefundableType } from "../../../enums/CreditResourceType";

// Colored pill for a credit's CreditResourceType.
// Iyzico-refundable types (OnlineSale, HuaweiIyzico, External) get a distinct
// accent so operators can spot refundable rows at a glance.
export function CreditTypeBadge({ type }) {
  const refundable = isRefundableType(type);
  return (
    <span
      className={`credit-badge credit-type-badge ${refundable ? "is-refundable" : ""}`}
      title={refundable ? "Iyzico iade destekli" : undefined}
    >
      {getCreditTypeLabel(type)}
      <span className="credit-badge-num">{type}</span>
    </span>
  );
}

// Status pill. The backend Status is a small integer/string; we colour a few
// well-known states and fall back to a neutral pill for the rest.
export function StatusBadge({ status }) {
  const value = String(status);
  let tone = "neutral";
  if (value === "1" || value.toLowerCase() === "active") tone = "success";
  else if (value === "0" || value.toLowerCase() === "passive") tone = "muted";
  else if (value === "2") tone = "warning";

  return <span className={`credit-badge status-badge tone-${tone}`}>{value}</span>;
}
